/* eslint-disable react-hooks/exhaustive-deps */
import {useRef, useEffect, useState} from "react"
import {Checkbox} from "antd"
import cx from "classnames"
import {BaseInput} from "components/inputs"
import {KlassDropdown} from "components/Select"
import {FormLabel} from "components/Form"
import {CHECKBOX_TYPES} from "sections/Tasks/data"
import {getContentPositionStyle} from "./utils"
import styles from "./FieldActionItem.module.css"
import {Actions} from "./Actions"
import {useVisible} from "hooks"
import {ConditionalRules} from "./ConditionalRules"

type Props = {
    field: any
    fields: any[]
    definedUsers: any[]
    scaleInfo: any
    totalPage: number
    isEditable: boolean
    onClickDelete: (field: any) => void
    onChangeField: (field: any) => void
    onDuplicateField: (field: any) => void
}

export function FileForm({
    field,
    fields,
    definedUsers,
    scaleInfo,
    totalPage,
    isEditable,
    onClickDelete,
    onChangeField,
    onDuplicateField
}: Props) {
    const bodyRef = useRef(null)
    const contentScroll = useVisible(true)
    const [style, setStyle] = useState({})

    useEffect(() => {
        if (!bodyRef || !bodyRef.current) {
            return
        }
        const style = getContentPositionStyle(bodyRef, field, scaleInfo, totalPage)
        setStyle(style)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bodyRef])

    const onChangeData = (key, value) => {
        if (!isEditable) {
            return
        }
        field[key] = value
        onChangeField(field)
    }

    return (
        <div
            ref={bodyRef}
            className={cx(styles.bodyContent, {
                [styles.bodyContentHiddenScroll]: !contentScroll.isVisible
            })}
            style={style}>
            <div className={styles.bodyHeader}>
                <p className={styles.bodyHeaderTitle}>File</p>
                <Actions
                    field={field}
                    isEditable={isEditable}
                    onClickDelete={onClickDelete}
                    onDuplicateField={onDuplicateField}
                />
            </div>
            <div className={styles.formItem}>
                <FormLabel label="Label" />
                <BaseInput
                    placeholder="Label"
                    value={field.label}
                    onChange={(newValue) => onChangeData("label", newValue)}
                />
            </div>
            <div className={styles.formItem}>
                <FormLabel label="Signers" />
                <KlassDropdown
                    options={definedUsers}
                    labelKey="label"
                    value={field.signatureTypes}
                    onChange={(newValue) => onChangeData("signatureTypes", newValue)}
                    isMulti
                    onMenuOpen={contentScroll.close}
                    onMenuClose={contentScroll.open}
                    menuPortalTarget={null}
                />
            </div>
            <div className={styles.formItem}>
                <Checkbox
                    checked={field.required}
                    onChange={({target: {checked}}) => onChangeData("required", checked)}>
                    <span>Required</span>
                </Checkbox>
            </div>
            <div className={styles.formItem}>
                <FormLabel label="File type" />
                <KlassDropdown
                    options={CHECKBOX_TYPES}
                    value={field.fileType}
                    onChange={(newValue) => onChangeData("fileType", newValue)}
                    onMenuOpen={contentScroll.close}
                    onMenuClose={contentScroll.open}
                    menuPortalTarget={null}
                />
            </div>
            <ConditionalRules field={field} fields={fields} isEditable={isEditable} onChangeField={onChangeField} />
        </div>
    )
}
